module.exports = __webpack_public_path__ + "img/image_news_TXT_collabo04.bb08ed56.png";